import React from "react";

/**
 * Zone assignment section for species form
 * Allows selecting which areas/zones a species can be found in
 * 
 * @param {Array} selectedSpeciesZones - Array of selected zone IDs
 * @param {Function} setSelectedSpeciesZones - Setter for selected zones
 * @param {boolean} isSpeciesZoneDropdownOpen - Dropdown open state
 * @param {Function} setIsSpeciesZoneDropdownOpen - Setter for dropdown state
 * @param {Array} areasList - List of available areas {id, name}
 * @param {Function} handleSpeciesZoneToggle - Handler for toggling zone selection
 * @param {Object} speciesZoneDropdownRef - Ref for dropdown
 */
export default function ZoneAssignmentSection({
    selectedSpeciesZones,
    setSelectedSpeciesZones,
    isSpeciesZoneDropdownOpen,
    setIsSpeciesZoneDropdownOpen,
    areasList,
    handleSpeciesZoneToggle,
    speciesZoneDropdownRef
}) {
    return (
        <div>
            <label className="block text-sm font-semibold text-charcoal mb-2">
                Områden
            </label>
            <div className="relative" ref={speciesZoneDropdownRef}>
                <button
                    type="button"
                    onClick={() => setIsSpeciesZoneDropdownOpen(!isSpeciesZoneDropdownOpen)}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-forest focus:border-transparent text-left flex items-center justify-between bg-white hover:bg-gray-50"
                >
                    <span className="text-gray-700">
                        {selectedSpeciesZones.length > 0 
                            ? `${selectedSpeciesZones.length} område(n) vald` 
                            : 'Välj områden för denna art'}
                    </span>
                    <svg 
                        className={`w-5 h-5 text-gray-400 transition-transform ${isSpeciesZoneDropdownOpen ? 'rotate-180' : ''}`}
                        fill="none" 
                        stroke="currentColor" 
                        viewBox="0 0 24 24"
                    >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                </button>
                
                {isSpeciesZoneDropdownOpen && (
                    <div className="absolute z-10 w-full mt-2 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto">
                        <div className="p-2">
                            {areasList && areasList.length > 0 ? (
                                areasList.map((area) => (
                                    <label
                                        key={area.id}
                                        className="flex items-center px-3 py-2 hover:bg-gray-100 rounded cursor-pointer"
                                    >
                                        <input
                                            type="checkbox"
                                            checked={selectedSpeciesZones.includes(area.id)}
                                            onChange={() => handleSpeciesZoneToggle(area.id)}
                                            className="w-4 h-4 text-forest bg-white border-gray-300 rounded focus:ring-forest focus:ring-2"
                                        />
                                        <span className="ml-3 text-gray-700">{area.name}</span>
                                    </label>
                                ))
                            ) : (
                                <p className="px-3 py-2 text-gray-500 text-sm">Inga områden tillgängliga</p>
                            )}
                        </div>
                        {selectedSpeciesZones.length > 0 && (
                            <div className="border-t border-gray-200 p-2">
                                <button
                                    type="button"
                                    onClick={() => setSelectedSpeciesZones([])}
                                    className="w-full px-3 py-2 text-sm text-forest hover:bg-sage/20 rounded transition-colors"
                                >
                                    Rensa alla områden
                                </button>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}
